var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Div } from './div';
import React from 'react';
import { Col, Row, Spacer } from '../Grid';
export var Chip = React.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var forwardRef = React.useRef(null);
    React.useEffect(function () { if (ref) {
        if (typeof ref === "function") {
            ref(forwardRef.current);
        }
        else {
            ref.current = forwardRef.current;
        }
    } });
    return _jsx(_Fragment, { children: _jsxs(Div, __assign({ display: 'inline-block', borderRadiusAll: 3, paddingY: 3, paddingX: 8, "box-shadow-1": true, color: 'surface-7', textColor: 'white' }, props, { ref: forwardRef }, { children: [!children &&
                    _jsxs(Row, __assign({ fullWidth: true, center: true }, { children: [_jsx(Col, __assign({ show: !!props.contentLeft, center: true }, { children: props.contentLeft || null })), _jsx(Spacer, __assign({ center: true, "px-1": true }, { children: props.label || null })), _jsx(Col, __assign({ show: !!props.contentRight, center: true }, { children: props.contentRight || null }))] })), children] })) });
});
